<template>
  <div class="pie" :style="{height:wapperHeight}">
    <div class="pie__title" flex="main:center cross:center">销售渠道</div>
    <ve-pie
      style="left:50%;transform:translateX(-50%);"
            :width="pieWidth"
      :height="pieHeight"
      :data="chartData"
      color="#fff"
      :textStyle="textStyle"
      :settings="chartSettings"
      :extend="percentExtend"
    ></ve-pie>
  </div>
</template>

<script>
import VePie from 'v-charts/lib/pie'

export default {
  components: { VePie },
  name: 'pieChart',
  data () {
    let clientHeight = document.body.clientHeight - 30
    function getValue (per) {
      return (per * clientHeight) / 100
    }
    this.chartSettings = {
      roseType: 'radius',
      radius: getValue(5),
      offsetY: getValue(6.5),
      label: {
        show: false
      }
      //  level: [
      //   ['1/1', '1/2', '1/3'],
      //   ['1/4', '1/5']
      // ]
    }
    return {
      wapperHeight: getValue(26) + 'px',
      pieWidth: getValue(22) + 'px',
      pieHeight: getValue(20) + 'px',
      textStyle: {
        color: '#fff',
        fontWeight: 'bold'
      },
      percentExtend: {
        legend: {
          top: getValue(20),
          // right:0,
          icon: 'pin',
          // orient: "vertical",
          textStyle: {
            color: '#fff',
            fontSize: '8'
          }
        }
      },
      percentExtend: {
        legend: {
          top: getValue(13),
          // right:0,
          icon: 'pin',
          // orient: "vertical",
          textStyle: {
            color: '#fff',
            fontSize: '8'
          }
        }
      },
      chartData: {
        columns: ['日期', '微信', '支付宝'],
        rows: [
          { 日期: '11-1', 微信: 800, 支付宝: 500, 银行卡: 300, 现金: 0 },
          { 日期: '11-2', 微信: 800, 支付宝: 500, 银行卡: 11, 现金: 0 },
          { 日期: '11-3', 微信: 800, 支付宝: 1500, 银行卡: 300, 现金: 0 },
          { 日期: '11-4', 微信: 800, 支付宝: 500, 银行卡: 11, 现金: 0 },
          { 日期: '11-5', 微信: 800, 支付宝: 500, 银行卡: 11, 现金: 0 },
          { 日期: '11-6', 微信: 800, 支付宝: 500, 银行卡: 300, 现金: 0 }
        ]
      }
    }
  },
  methods: {
    onHandleToggleDate (item, index) {
      this.tooggleDateIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.pie {
  background-image: url("../../image/pie.png");
  background-size: 100% 100%;
  background-color: rgba(19, 54, 79, 0);
  color: #fff;
  width: 100%;
  height: 238px;
  touch-action: none;
  &__title {
    height: 0.5rem;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
